import React, { FunctionComponent } from 'react';

import Modal from '../Modal/Modal';

import styles from './PopupBlockedModal.scss';
import { useTranslation } from 'react-i18next';
import { useApp } from '../../hooks';
import Button from '../Button/Button';
import clientConfig from '../../client/config';

type PopupBlockedModalProps = {
  onClose: () => void;
};

export const PopupBlockedModal: FunctionComponent<PopupBlockedModalProps> = ({
  onClose,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { checkoutHref } = useApp();

  // Remove 'checkoutMode=Headless' param, as checkout is opening in a new full-size tab/window, not in a pop-up
  const finalCheckoutUrl = checkoutHref.replace('checkoutMode=Headless', '');

  return (
    <Modal
      onCloseRequest={onClose}
      className={styles.modal}
      modalTitle={t('popupBlockedModal.title')}
      removeScrollbar
      displayCloseButton
    >
      <img
        src={`${clientConfig.imageServiceUrl}JG_Roundel_Laptop_User1.png`}
        alt=""
        className={styles.image}
      />
      <h1>{t('popupBlockedModal.heading')}</h1>
      <p className={styles.message}>{t('popupBlockedModal.message')}</p>
      <Button className={styles.button} onClick={onClose}>
        {t('popupBlockedModal.cta.tryAgain')}
      </Button>
      <a
        href={finalCheckoutUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClose}
      >
        {t('popupBlockedModal.cta.openCheckoutNewWindow')}
      </a>
    </Modal>
  );
};
